import React, { useState } from 'react'
import PropTypes from 'prop-types'

// Components
import IconAttachedFile from 'ui/Icons/IconAttachedFile'
import Loading from 'ui/Loading'

// Styles
import './FileItemAttachment.scss'

export const FileItemAttachment = ({ name, onClick }) => {
  const [loading, setLoading] = useState(false)
  const displayName = name.split('/').pop()

  return (
    <div className="x-file-attachment">
      <div className="left">
        {loading ? (
          <Loading spinning={loading} size={20}></Loading>
        ) : (
          <IconAttachedFile width={'25px'} />
        )}
      </div>

      <div className="center">
        <span
          className="name"
          onClick={() => {
            if (!loading && onClick) {
              onClick(name, setLoading)
            }
          }}
        >
          {displayName}
        </span>
      </div>
    </div>
  )
}

FileItemAttachment.propTypes = {
  name: PropTypes.string,
  onClick: PropTypes.func,
}

FileItemAttachment.defaultProps = {
  name: '',
  onClick: null,
}

export default FileItemAttachment
